<div class="popup" *ngIf="location">
    <div class="popup-actions">

        <app-copy-clipboard
                            [class.fixed_position]="!autoRemove"
                            [message]="'Copied to clipboard'"
                            [tooltipPosition]="'below'"
                            [value]="clipToClipboard()"></app-copy-clipboard>
        <button [hidden]="!autoRemove" matIconButton class="mat-icon-button-small delete-icon" (click)="removeInfoProperties()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="pin">
        <custom-pin [height]="infoProperty.selected ? 23 : 21" [width]="infoProperty.selected ? 20 : 13" [fillColor]="pinColor" (click)="showPin()"></custom-pin>
    </div>

    <div class="data-div">
        <div class="address" *ngIf="address">{{address}}</div>
        <div class="address-placeholder" matTooltip="Gathering information for this location" *ngIf="infoLoading && !address">{{address}}</div>
        <div class="location" *ngIf="address">{{location[1] | number: '1.6-6'}}, {{location[0] | number: '1.6-6'}} </div>
        <div class="location-placeholder" matTooltip="Gathering information for this location" *ngIf="infoLoading && !address"></div>
        <div class="date-placeholder"  matTooltip="Gathering information for this location" *ngIf="infoLoading && !address"></div>
    </div>
</div>
